import React from "react";
import { FiUsers } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import PageLoader from "../components/PageLoader";
import { selectActiveUserCount, selectUsers } from "../store/usersSlice";
import styles from "./AdminDashboardPage.module.css";

export default function AdminDashboardPage() {
  const users = useSelector(selectUsers);
  const activeCount = useSelector(selectActiveUserCount);
  const { booting = false } = useOutletContext() || {};
  const registeredCount = users.length;

  if (booting && users.length === 0) {
    return <PageLoader label="Loading dashboard..." />;
  }

  return (
    <div className={styles.wrap}>
      <div className="pageCard" style={{ padding: "1.3rem" }}>
        <h2 className="sectionTitle">Dashboard</h2>
        <p className="muted">Quick portal stats at a glance.</p>
        <div className={styles.cards}>
          <article className={styles.card}>
            <span>Registered clients</span>
            <strong>{registeredCount}</strong>
            <FiUsers />
          </article>
          <article className={styles.card}>
            <span>Active clients</span>
            <strong>{activeCount}</strong>
            <FiUsers />
          </article>
        </div>
      </div>
    </div>
  );
}
